import classNames from 'classnames';
import { t } from 'i18next';
import React from 'react';
import { AiOutlineDelete } from 'react-icons/ai';
import { IoMdAddCircleOutline } from 'react-icons/io';
import { IoChevronBackCircleOutline, IoChevronForwardCircleOutline } from 'react-icons/io5';
import MButton from 'views/Buttons/MButton/MButton';
import classes from './MFormFooter.module.scss';
import { ThemeColors } from 'models/general';
import { getCurrentDirection } from 'utils/helpers';
import { LanguageDirection } from 'utils/enums/language';

type Props = {
  cancelText?: string;
  removeText?: string;
  confirmText?: string;
  submitAndCreate?: string;
  className?: string;
  disabled?: boolean;
  elementToEnd?: React.ReactNode;
  onCancel?: () => void;
  onRemove?: () => void;
  onSubmitAndReset?: () => void;
};

const MFormFooterButtonsView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={classes['container']}>
      <div className={classes['submitActions']}>
        <MButton disabled={props.disabled} type="submit" className={classNames(classes['button'], props.className)}>
          {props.confirmText}
          {getCurrentDirection() === LanguageDirection.RTL ? (
            <IoChevronBackCircleOutline className={classes['button--icon']} />
          ) : (
            <IoChevronForwardCircleOutline className={classes['button--icon']} />
          )}
        </MButton>
        {props.onSubmitAndReset ? (
          <MButton
            disabled={props.disabled}
            type="button"
            className={classNames(classes['button'], classes['button--removeMargin'], props.className)}
            onClick={props.onSubmitAndReset}
          >
            {props.submitAndCreate}
            <IoMdAddCircleOutline className={classes['button--icon']} />
          </MButton>
        ) : null}
      </div>

      {props.onCancel ? (
        <MButton type="button" className={classes['button']} color={ThemeColors.Secondary} onClick={props.onCancel}>
          {props.cancelText}
        </MButton>
      ) : null}

      {props.onRemove ? (
        <MButton type="button" className={classes['button']} color={ThemeColors.Danger} onClick={props.onRemove}>
          {props.removeText} <AiOutlineDelete className={classes['button--icon']} />
        </MButton>
      ) : null}

      {props.elementToEnd ? props.elementToEnd : null}
    </div>
  );
};

MFormFooterButtonsView.displayName = 'MFormFooterButtonsView';
MFormFooterButtonsView.defaultProps = {
  cancelText: t('views.button.text.cancel'),
  confirmText: t('views.button.text.submit'),
};

export default MFormFooterButtonsView;
